// db-settings.js

let activePresetName = null;
let isPanelSticky = false;

function toggleColumnPanel(rebuildOnly = false) {
  const panel = document.getElementById("columnTogglePanel");
  const wrapper = document.getElementById("tableWrapper");
  const sidebar = document.getElementById("sidebarFilterPanel");

  if (sidebar && window.sidebarIsOpen) {
    sidebar.style.transform = "translateX(-100%)";
    window.sidebarIsOpen = false;

    const filterBtn = document.getElementById("toggleSidebarFilterBtn");
    if (filterBtn) {
      filterBtn.classList.remove("active");
      filterBtn.innerHTML = `
      <img src="https://cdn.shopify.com/s/files/1/0102/8426/9615/files/filter---filled-_24x24_1x_27c9eff6-a79d-417b-a447-5e0ce0d5fe2c.svg?v=" />
    `;
    }
  }

    if (!window.isGridView) {
      wrapper.style.transform    = "";
      wrapper.style.paddingRight = "";
    }

  if (!panel || !window.allHeaders) return;

  if (!rebuildOnly) {
    if (panel.style.transform === "translateX(0px)") {
      panel.style.transform = "translateX(100%)";
      // (optional) void panel.offsetWidth; // only if you need to force the reverse animation
      if (wrapper) {
        wrapper.style.paddingRight = "";
        wrapper.style.transform = "";
      }

      setTimeout(() => {
        const icon = document.getElementById("settingsIcon");
        if (icon) {
          icon.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0102/8426/9615/files/settings.svg?v=1750358988" />`;
          document.getElementById("editColumnsBtn")?.classList.remove("active");
        }
      }, 100);

      return;
    }
  }

  const fullscreenTarget = document.getElementById("tableContainer");
  (fullscreenTarget || document.body).appendChild(panel);

  // Update to remove dependency on header and section
  const updateSidebarPosition = () => {
    const scrollTop = window.scrollY;
    const headerHeight = 0;  // No header height since the header is removed

    const windowHeight = window.innerHeight;

    if (scrollTop + headerHeight >= windowHeight) {
      panel.style.position = "fixed";
      panel.style.top = `${headerHeight}px`;
    } else {
      panel.style.position = "absolute";
      panel.style.top = `${scrollTop + headerHeight}px`;
    }
  };

  window.addEventListener("scroll", updateSidebarPosition);
  window.addEventListener("resize", updateSidebarPosition);
  updateSidebarPosition();

  const savedPresets = loadLocal(`columnPresets-${currentProductType}`, {});
  panel.innerHTML = `
    <div style="padding: 8px; max-width: 500px; display: flex; flex-direction: column; gap: 8px; font-size: 15px;">
   <!--— Saved Comparisons —-->
   <h3 style="font-size: 16px; font-weight: bold; padding: 40px 0 10px; text-transform: uppercase; line-height: 20px; color: #000; border-bottom: 1px solid #000;">Saves</h3>
   <div>
     <div id="savedComparisonsContainer" class="saved-comparisons-container"></div>
   </div>
   
     <!--— Saved Favourites —-->
    <div id="savedFavoritesContainer" class="saved-favorites-container" style="margin-top: 8px;"></div>

   <!--— Saved Tier Lists —-->
   <div style="display: none;">
     <div id="savedTierListsContainer" class="saved-tier-lists-container"></div>
   </div>
   
   <!--— Table Settings —-->
   <h3 style="font-size: 16px; font-weight: bold; padding: 40px 0 10px; text-transform: uppercase; line-height: 20px; color: #000; border-bottom: 1px solid #000;">Table Settings</h3>
   <p style="color: #000; margin: -20px 0 10px; font-size: 14px;">Only applicable to table view.</p>       
   <p style="color: #000; font-weight: 500; margin: 0; font-size: 16px;">Default Presets</p>
      <select id="presetSelector" onchange="applyPreset(this.value)">
        <option value="">Select preset...</option>
        <option value="compact">Compact View</option>
        <option value="dims">Dims Only</option>
      </select>
      <div id="userPresetList" style="margin: 4px 0 10px;"></div>
      <label style="color: #000;">Drag to reorder. Uncheck to hide.</label>
      <div class="column-button-container">
        <button onclick="selectAllColumns()">Select All</button>
        <button onclick="deselectAllColumns()">Deselect All</button>
        <button onclick="saveCurrentLayoutAsPreset()" style="color: #d42e2e">Save</button>
      </div>
      <div style="background: #f6f6f6; max-height: 300px; scrollbar-width: thin; overflow-y: auto; border: 1px solid #ccc; border-radius: 5px; padding: 10px; font-size: 14px;">
        <ul id="columnList" style="list-style: none; padding: 0; margin: 0;"></ul>
      </div>
      <div id="columnCounter" style="text-align: left; font-size: 14px; margin-top: 0;">0 columns visible</div>
      <div style="display: flex; justify-content: flex-end; font-size: 14px; gap: 10px;">
        <button onclick="saveColumnPreferences()" style="background: #fb0440; color: white; padding: 2px 10px; border: none; border-radius: 5px;">Apply</button>
        <button onclick="resetColumnPreferences()" style="background: #000; color: white; padding: 2px 10px; border: none; border-radius: 5px;">Reset</button>
      </div>
    </div>
  `;

  renderSavedComparisons();
  renderSavedFavorites();

  const userPresetList = document.getElementById("userPresetList");
  userPresetList.innerHTML = "";

  const savedPresetNames = Object.keys(savedPresets).sort((a, b) =>
    a.localeCompare(b)
  );

  if (savedPresetNames.length > 0) {
    const html = savedPresetNames
      .map((name) => {
        const isActive = name === activePresetName;
        const classes = ["saved-list-items"];
        if (isActive) classes.push("active");

        return `
      <div class="${classes.join(" ")}">
        <span class="editable-name" data-name="${name}" onclick="applyUserPreset('${name}'); rebuildColumnPanelContents();">${name}</span>
        <div class="saved-item-buttons">
          <button onclick="renameUserPreset('${name}')" title="Rename">✎</button>
          <button class="saved-item-delete" onclick="confirmDeletePreset('${name}')" title="Delete">×</button>
        </div>
      </div>
    `;
      })
      .join("");

    userPresetList.innerHTML = `
    <h3 class="button-labels">My Presets</h3>
    ${html}
  `;
  }

  const list = document.getElementById("columnList");

  window.allHeaders.forEach((header) => {
    const li = document.createElement("li");
    li.style.marginBottom = "0";
    li.style.display = "flex";
    li.style.alignItems = "center";
    li.style.justifyContent = "space-between";
    li.style.cursor = "grab";
    li.style.padding = "2px 3px";
    li.style.userSelect = "none";

    const leftSide = document.createElement("div");
    leftSide.style.display = "flex";
    leftSide.style.alignItems = "center";

    const dragIcon = document.createElement("span");
    dragIcon.innerHTML = "&#9776;";
    dragIcon.style.marginRight = "8px";
    dragIcon.style.fontSize = "18px";
    dragIcon.title = "Drag to reorder";

    const text = document.createTextNode(header.label);

    leftSide.appendChild(dragIcon);
    leftSide.appendChild(text);

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = !hiddenColumns.includes(header.label);
    checkbox.dataset.column = header.label;
    checkbox.style.marginLeft = "12px";

    li.appendChild(leftSide);
    li.appendChild(checkbox);
    list.appendChild(li);

    checkbox.addEventListener("change", () => {
      const col = checkbox.dataset.column;
      if (checkbox.checked) {
        hiddenColumns = hiddenColumns.filter((h) => h !== col);
      } else {
        if (!hiddenColumns.includes(col)) hiddenColumns.push(col);
      }
      renderProductsTable(currentFilteredProducts, currentProductType);
      updateColumnCounter();
      li.classList.add("flash-change");
      setTimeout(() => li.classList.remove("flash-change"), 400);
    });

    li.addEventListener("click", (e) => {
      if (e.target !== checkbox) {
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });

  Sortable.create(list, { animation: 150 });

  updateColumnCounter();

 panel.style.display = "block";
 // ── force layout so Firefox sees the 'off-screen' state first ──
 void panel.offsetWidth;
 panel.style.transform = "translateX(0)";

  setTimeout(() => {
    const icon = document.getElementById("settingsIcon");
    if (icon) {
      icon.innerHTML = "&times;";
      document.getElementById("editColumnsBtn")?.classList.add("active");
    }
  }, 100);

  if (wrapper && !window.isGridView) {
    wrapper.style.paddingRight = "300px";
  }
}

function renderSavedFavorites() {
  const container = document.getElementById("savedFavoritesContainer");
  if (!container) return;

  const savedLists = loadLocal("savedFavoriteLists", {});
  const names = Object.keys(savedLists);

  if (names.length === 0) {
    container.innerHTML = "";
  } else {
    const html = names
      .map((name) => {
        const isActive = name === activeFavoriteName;
        const classes = ["saved-list-items"];
        if (isActive) classes.push("active");

        return `
        <div class="${classes.join(" ")}">
          <span class="editable-name" data-name="${name}" onclick="loadFavoriteList('${name}')">${name}</span>
          <div class="saved-item-buttons">
            <button onclick="renameFavoriteList('${name}')" title="Rename">✎</button>
            <button class="saved-item-delete" onclick="deleteFavoriteList('${name}')" title="Delete">×</button>
          </div>
        </div>
      `;
      })
      .join("");

    container.innerHTML = `
      <h3 class="button-labels">Favourites</h3>
      ${html}
    `;
  }
  updateSavedListsEmptyState();
}

function extractId(gid) {
  return gid?.split("/").pop();
}

function loadFavoriteList(name) {
  const savedLists = loadLocal("savedFavoriteLists", {});
  const list = savedLists[name];
  if (!list) return;

  favoritedProducts = list.slice();
  // persist into the key your toggle-UI reads
  saveLocal("favoritedProducts", favoritedProducts);

  renderProductsTable(currentFilteredProducts, currentProductType);
  setTimeout(() => {
    if (favToggle?.checked) {
      favToggle.dispatchEvent(new Event("change"));
    }
  }, 0);

  const favToggle = document.getElementById("toggleFavoritesCheckbox");
  if (favToggle && !favToggle.checked) {
    favToggle.checked = true;
    favToggle.closest(".switch-toggle").style.display = "inline-flex";
    favToggle.dispatchEvent(new Event("change"));
  }

  activeFavoriteName = name;
  showToast(`Loaded "${name}" favorites`);
  renderSavedFavorites();
  updateFavoritesToggleUI();
  waitForProductRowsThenHighlightFavorites();
}

function waitForProductRowsThenHighlightFavorites() {
  const maxRetries = 20;
  let attempt = 0;

  const check = () => {
    const firstGid = favoritedProducts[0];
    const row = document.querySelector(`tr[data-product-id="${firstGid}"]`);

    if (row) {
      favoritedProducts.forEach((gid) => {
        const row = document.querySelector(`tr[data-product-id="${gid}"]`);
        const favBtn = row?.querySelector(".favorite-btn");

        if (row) row.classList.add("row-favorited");
        if (favBtn) {
          favBtn.classList.add("favorited");
          favBtn.textContent = "♥";
        }
      });
    } else if (attempt < maxRetries) {
      attempt++;
      setTimeout(check, 100);
    } else {
      console.warn("Favourites not applied — product rows not found in time.");
    }
  };

  check();
}

function renameFavoriteList(oldName) {
  showInputModal(`Rename "${oldName}" favourites to:`, (newName) => {
    if (!newName || newName === oldName) return;

    const key = "savedFavoriteLists";
    const saved = loadLocal(key, {});

    if (saved[newName]) {
      showToast("Name already exists.", "error");
      return;
    }

    saved[newName] = saved[oldName];
    delete saved[oldName];
    saveLocal(key, saved);

    showToast(`Renamed to "${newName}"`);
    renderSavedFavorites();
  });
}

function renameUserPreset(oldName) {
  showInputModal(`Rename preset "${oldName}" to:`, (newName) => {
    if (!newName || newName === oldName) return;

    const key = `columnPresets-${currentProductType}`;
    const saved = loadLocal(key, {});

    if (saved[newName]) {
      showToast("Name already exists.", "error");
      return;
    }

    saved[newName] = saved[oldName];
    delete saved[oldName];
    saveLocal(key, saved);

    if (activePresetName === oldName) {
      activePresetName = newName;
    }

    showToast(`Preset renamed to "${newName}"`);
    rebuildColumnPanelContents();
  });
}

function deleteFavoriteList(name) {
  showConfirmModal(`Delete "${name}" favourite list?`, (confirmed) => {
    if (!confirmed) return;

    const key = "savedFavoriteLists";
    const savedLists = loadLocal(key, {});
    delete savedLists[name];
    saveLocal(key, savedLists);
    renderSavedFavorites();
    showToast(`Deleted "${name}"`);
  });
}

function updateSavedListsEmptyState() {
  const favContainer = document.getElementById("savedFavoritesContainer");
  const compContainer = document.getElementById("savedComparisonsContainer");

  const hasFavorites =
    favContainer && favContainer.querySelector(".saved-list-items");
  const hasComparisons =
    compContainer && compContainer.querySelector(".saved-list-items");

  const alreadyExists = document.getElementById("noSavedListsMessage");

  if (!hasFavorites && !hasComparisons) {
    if (!alreadyExists) {
      const message = document.createElement("div");
      message.id = "noSavedListsMessage";
      message.textContent = "No saved lists.";
      message.style.fontSize = "14px";
      message.style.color = "#777";
      message.style.marginTop = "8px";

      if (compContainer && compContainer.parentElement) {
        compContainer.parentElement.appendChild(message);
      }
    }
  } else if (alreadyExists) {
    alreadyExists.remove();
  }
}

function rebuildColumnPanelContents() {
  if (!window.allHeaders) return;

  const panel = document.getElementById("columnTogglePanel");
  if (!panel) return;

  panel.innerHTML = "";
  toggleColumnPanel(true);
}

function saveColumnPreferences() {
  const panel = document.getElementById("columnTogglePanel");
  const listItems = panel.querySelectorAll("#columnList li");

  const newOrder = [];
  const newHidden = [];

  listItems.forEach((li) => {
    const checkbox = li.querySelector("input[type='checkbox']");
    const column = checkbox.dataset.column;
    newOrder.push(column);

    if (!checkbox.checked) {
      newHidden.push(column);
    }
  });

  saveLocal(`columnOrder-${currentProductType}`, newOrder);
  saveLocal(`hiddenColumns-${currentProductType}`, newHidden);

  hiddenColumns = newHidden;
  renderProductsTable(currentFilteredProducts, currentProductType);
  refreshColumnPanel();
}

function saveCurrentLayoutAsPreset() {
  showInputModal("Enter a name for your preset:", (name) => {
    if (!name) return;

    const key = `columnPresets-${currentProductType}`;
    const existingPresets = loadLocal(key, {});

    if (existingPresets[name]) {
      const confirmOverwrite = confirm(
        `A preset named "${name}" already exists. Overwrite it?`
      );
      if (!confirmOverwrite) {
        return;
      }
    }

    const panel = document.getElementById("columnTogglePanel");
    const listItems = panel.querySelectorAll("#columnList li");

    const newOrder = [];
    const newHidden = [];

    listItems.forEach((li) => {
      const checkbox = li.querySelector("input[type='checkbox']");
      const column = checkbox.dataset.column;
      newOrder.push(column);

      if (!checkbox.checked) {
        newHidden.push(column);
      }
    });

    existingPresets[name] = {
      order: newOrder,
      hidden: newHidden,
    };

    saveLocal(key, existingPresets);

    showToast(`Preset "${name}" saved!`);
    rebuildColumnPanelContents();
  });
}

function deletePreset(name) {
  const key = `columnPresets-${currentProductType}`;
  const savedPresets = loadLocal(key, {});

  delete savedPresets[name];
  saveLocal(key, savedPresets);

  showToast(`Preset "${name}" deleted.`, "info");

  rebuildColumnPanelContents();
}

function confirmDeletePreset(name) {
  showConfirmModal(`Delete preset "${name}"?`, (confirmed) => {
    if (confirmed) {
      deletePreset(name);
    }
  });
}

function selectAllColumns() {
  document
    .querySelectorAll("#columnList input[type='checkbox']")
    .forEach((cb) => {
      if (!cb.checked) {
        cb.checked = true;
        cb.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

  activePresetName = null;
  rebuildColumnPanelContents();
}

function deselectAllColumns() {
  document
    .querySelectorAll("#columnList input[type='checkbox']")
    .forEach((cb) => {
      if (cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

  activePresetName = null;
  rebuildColumnPanelContents();
}

function resetColumnPreferences() {
  localStorage.removeItem(`columnOrder-${currentProductType}`);
  localStorage.removeItem(`hiddenColumns-${currentProductType}`);

  hiddenColumns = [];
  activePresetName = null;
  renderProductsTable(currentFilteredProducts, currentProductType);
  rebuildColumnPanelContents();
}

const compactViewPresets = {
  Mousepads: [
    "Price",
    "Stock",
    "Size",
    "Base",
    "Stitched",
    "Packaged",
    "Washable",
    "Game Type",
    "Lighting",
    "Warranty",
  ],
  "Mouse Feet": [
    "Price",
    "Stock",
    "Compatibility",
    "Thickness",
    "Material",
    "Rounded Edges",
    "Colour",
    "In the box",
  ],
};

function applyCompactView() {
  const preset = compactViewPresets[currentProductType] || [];

  hiddenColumns = preset.slice();

  localStorage.removeItem(`columnOrder-${currentProductType}`);
  saveLocal(`hiddenColumns-${currentProductType}`, hiddenColumns);
  renderProductsTable(currentFilteredProducts, currentProductType);

  rebuildColumnPanelContents();
}

const DimsOnlyViewPresets = {
  Mousepads: [
    "Price",
    "Stock",
    "Size",
    "Type",
    "Surface",
    "Base",
    "Stitched",
    "Colour",
    "Packaged",
    "Washable",
    "Game Type",
    "Graphics",
    "Static Friction",
    "Dynamic Friction",
    "Glide Type",
    "Firmness",
    "Coating",
    "Texture",
    "Lighting",
    "Warranty",
  ],
  "Mouse Feet": [
    "Price",
    "Stock",
    "Compatibility",
    "Material",
    "Rounded Edges",
    "Colour",
    "In the box",
  ],
};

function applyDimsOnlyView() {
  const preset = DimsOnlyViewPresets[currentProductType] || [];

  hiddenColumns = preset.slice();

  localStorage.removeItem(`columnOrder-${currentProductType}`);
  saveLocal(`hiddenColumns-${currentProductType}`, hiddenColumns);
  renderProductsTable(currentFilteredProducts, currentProductType);

  rebuildColumnPanelContents();
}

function applyPreset(preset) {
  if (preset === "compact") {
    applyCompactView();
  } else if (preset === "dims") {
    applyDimsOnlyView();
  } else {
    const savedPresets = loadLocal(`columnPresets-${currentProductType}`, {});
    const selected = savedPresets[preset];
    if (selected) {
      hiddenColumns = selected.hidden.slice();
      saveLocal(`hiddenColumns-${currentProductType}`, hiddenColumns);
      saveLocal(`columnOrder-${currentProductType}`, selected.order);
      renderProductsTable(currentFilteredProducts, currentProductType);
      rebuildColumnPanelContents();
    }
  }
  const selector = document.getElementById("presetSelector");
  if (selector) {
    const selectedOption = selector.querySelector(`option[value="${preset}"]`);
    if (selectedOption) {
      selector.selectedIndex = selectedOption.index;
    } else {
      selector.selectedIndex = 0;
    }
  }
}

function applyUserPreset(name) {
  const savedPresets = loadLocal(`columnPresets-${currentProductType}`, {});
  const preset = savedPresets[name];

  if (!preset) return;

  hiddenColumns = preset.hidden.slice();
  saveLocal(`hiddenColumns-${currentProductType}`, hiddenColumns);
  saveLocal(`columnOrder-${currentProductType}`, preset.order);
  renderProductsTable(currentFilteredProducts, currentProductType);

  activePresetName = name;
  rebuildColumnPanelContents();
}

function updateColumnCounter() {
  const checkboxes = document.querySelectorAll(
    "#columnList input[type='checkbox']"
  );
  const visible = Array.from(checkboxes).filter((cb) => cb.checked).length;
  const total = checkboxes.length;
  const counter = document.getElementById("columnCounter");
  if (counter) counter.textContent = `${visible} of ${total} columns visible`;
}

function showToast(message, type = "info") {
  const toast = document.createElement("div");
  toast.textContent = message;
  toast.className = "toast";
  if (type === "error") {
    toast.classList.add("error");
  }

  const container = document.fullscreenElement || document.body;
  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = "1";
    toast.style.transform = "translateY(0)";
  }, 10);

  setTimeout(() => {
    toast.style.opacity = "0";
    toast.style.transform = "translateY(20px)";
    setTimeout(() => {
      toast.remove();
    }, 300);
  }, 2500);
}

function showInputModal(promptText, callback) {
  const overlay = document.createElement("div");
  overlay.className = "modal-overlay";

  const modal = document.createElement("div");
  modal.className = "modal-box";
  modal.classList.add("modal-animate");

  const prompt = document.createElement("div");
  prompt.textContent = promptText;
  prompt.style.fontSize = "16px";
  prompt.style.color = "#333";

  const input = document.createElement("input");
  input.type = "text";
  input.style.padding = "8px";
  input.style.fontSize = "14px";
  input.style.width = "100%";
  input.style.border = "1px solid #ccc";
  input.style.borderRadius = "4px";

  const buttons = document.createElement("div");
  buttons.className = "modal-buttons";

  const cancelBtn = document.createElement("button");
  cancelBtn.textContent = "Cancel";
  cancelBtn.className = "modal-button cancel";

  const saveBtn = document.createElement("button");
  saveBtn.textContent = "Save";
  saveBtn.className = "modal-button confirm";

  cancelBtn.onclick = () => overlay.remove();
  saveBtn.onclick = () => {
    const value = input.value.trim();
    overlay.remove();
    callback(value);
  };

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      saveBtn.click();
    }
  });

  buttons.appendChild(cancelBtn);
  buttons.appendChild(saveBtn);

  modal.appendChild(prompt);
  modal.appendChild(input);
  modal.appendChild(buttons);
  overlay.appendChild(modal);
  const container = document.fullscreenElement || document.body;
  container.appendChild(overlay);

  input.focus();
}

function showConfirmModal(message, callback) {
  const overlay = document.createElement("div");
  overlay.className = "modal-overlay";

  const modal = document.createElement("div");
  modal.className = "modal-box";
  modal.classList.add("modal-animate");

  const prompt = document.createElement("div");
  prompt.textContent = message;
  prompt.style.fontSize = "16px";
  prompt.style.color = "#333";

  const buttons = document.createElement("div");
  buttons.className = "modal-buttons";

  const cancelBtn = document.createElement("button");
  cancelBtn.textContent = "Cancel";
  cancelBtn.className = "modal-button cancel";

  const confirmBtn = document.createElement("button");
  confirmBtn.textContent = "Confirm";
  confirmBtn.className = "modal-button confirm";

  cancelBtn.onclick = () => {
    overlay.remove();
    callback(false);
  };

  confirmBtn.onclick = () => {
    overlay.remove();
    callback(true);
  };

  buttons.appendChild(cancelBtn);
  buttons.appendChild(confirmBtn);

  modal.appendChild(prompt);
  modal.appendChild(buttons);
  overlay.appendChild(modal);
  const container = document.fullscreenElement || document.body;
  container.appendChild(overlay);
}
